import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@pwc/appkit-react/lib/Banner';
import { Button } from '@pwc/appkit-react/lib/Button';

const CurrentPeriodWatcherBanner = ({ loadPeriods }) => {
  const warningMessage = (
    <>
      {`Current period has been updated`}
      <Button className="banner-button" onClick={loadPeriods}>Load periods</Button>
    </>
  );

  return (
    <div className="current-period-warning-banner">
      <Banner status="warning" content={warningMessage} />
    </div>
  );
};

CurrentPeriodWatcherBanner.propTypes = {
  loadPeriods: PropTypes.func,
};

export default CurrentPeriodWatcherBanner;
